// Sockologie: touch handling for the desktop mega menu (iPad landscape).
// The theme opens a dropdown on pointerenter and the top-level link is a real <a>,
// so on a touch screen a tap opened the menu AND navigated. Now, for touch only:
// first tap on a category with a dropdown opens it, second tap on the same
// category follows the link. Mouse and keyboard are untouched.
(function () {
  if (window.__skMegaTap) return;
  window.__skMegaTap = true;

  var lastPointerType = '';
  document.addEventListener('pointerdown', function (e) { lastPointerType = e.pointerType || ''; }, true);

  function isTouch(e) {
    if (typeof e.pointerType === 'string' && e.pointerType) return e.pointerType === 'touch' || e.pointerType === 'pen';
    return lastPointerType === 'touch' || lastPointerType === 'pen';
  }

  function clearFlags(menu) {
    menu.querySelectorAll('.menu-list__link[data-sk-tap-open]').forEach(function (a) { delete a.dataset.skTapOpen; });
  }

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var a = e.target.closest('header-menu .menu-list__link[aria-haspopup="true"]');
    if (!a || !isTouch(e)) return;
    var menu = a.closest('header-menu');
    if (!menu) return;
    if (a.dataset.skTapOpen === '1') { clearFlags(menu); return; }   // second tap: navigate
    e.preventDefault();
    clearFlags(menu);
    a.dataset.skTapOpen = '1';
    // activate() expects the <li> that contains the [ref=menuitem] link
    var item = a.closest('.menu-list__list-item') || a.parentElement;
    if (a.getAttribute('aria-expanded') !== 'true' && typeof menu.activate === 'function') menu.activate({ target: item });
  }, true);

  // When the dropdown closes (tap elsewhere, scroll away), the next tap opens again.
  function watch(menu) {
    new MutationObserver(function () {
      if (menu.getAttribute('aria-expanded') !== 'true') clearFlags(menu);
    }).observe(menu, { attributes: true, attributeFilter: ['aria-expanded'] });
  }
  function init() { document.querySelectorAll('header-menu').forEach(function (m) { if (!m.__skTapWatched) { m.__skTapWatched = true; watch(m); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
